<template>
  <v-card class="border--accent py-2 pl-2" color="#F1FAFA">
    <v-row>
      <v-col class="pt-0">
        <v-card-title>
          <span v-html="title"> </span>
          <slot name="titleExtension"></slot>
        </v-card-title>
        <v-card-subtitle v-html="subtitle" class="pt-2"> </v-card-subtitle>
        <slot></slot>
        <div class="ml-4 accent--text pb-4" v-if="$slots.helpText">
          <slot name="helpText"> </slot>
        </div>
      </v-col>
      <v-spacer class="limited-spacer"> </v-spacer>
      <v-col cols="12" sm="4" class="my-auto" v-if="image">
        <v-img :src="image" width="230" class="mx-auto"></v-img>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "AdHeaderCard",
  props: {
    title: { type: String },
    subtitle: { type: String },
    image: { type: String }
  },
  components: {},
  data: () => ({}),
  watch: {},
  computed: {},
  created() {},
  methods: {}
};
</script>
